import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import NacebelCodeEditor from "../../editors/masterdata/nacebelCode";

const NacebelCodes: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.NacebelCodesList}
			endpoint={Endpoint.NacebelCodes}
			addScreen={{ screen: NacebelCodeEditor, isAllowed: hasPermission(Permission.NacebelCodesAdd) }}
			editScreen={{ screen: NacebelCodeEditor, isAllowed: hasPermission(Permission.NacebelCodesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.NacebelCodesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default NacebelCodes;
